import React from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { useAppLibs } from "../../ContextProvider/AppLib_Provider";

// Register chart components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const LineChart = ({ assessment, labels }) => {
  const { Students } = useAppLibs();
  const criteriaMap = Students.STUDENT_CRITERIA;

  labels = labels
    ? labels
    : Object.keys(assessment).map((key) => criteriaMap[key]);
  const values = Object.values(assessment).map((val) => val * 10);

  // Line chart data
  const data = {
    labels,
    datasets: [
      {
        label: "Student Progress",
        data: values,
        backgroundColor: "rgba(0, 123, 255, 0.2)", // Light Blue Fill
        borderColor: "rgba(75, 192, 192, 1)",
        borderWidth: 2,
        pointBackgroundColor: "rgb(41, 182, 246)",
        pointRadius: 5,
        tension: 0.3, // Smooth curve
      },
    ],
  };

  // Chart options
  const options = {
    responsive: true,
    scales: {
      y: {
        min: 0,
        max: 100,
        ticks: { stepSize: 10 },
      },
    },
  };

  return <Line data={data} options={options} />;
};

export default LineChart;
